import { render, staticRenderFns } from "./ComplainType.vue?vue&type=template&id=4c453960&scoped=true"
import script from "./ComplainType.vue?vue&type=script&lang=js"
export * from "./ComplainType.vue?vue&type=script&lang=js"
import style0 from "./ComplainType.vue?vue&type=style&index=0&id=4c453960&prod&lang=scss&scoped=true"
import style1 from "./ComplainType.vue?vue&type=style&index=1&id=4c453960&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c453960",
  null
  
)

export default component.exports